import React from 'react';
import { Check } from 'lucide-react';

export function WhatsAppPreview({ message }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-100 p-4 shadow-sm" data-testid="whatsapp-preview">
      <div className="flex items-center gap-1.5 mb-3">
        <div className="w-4 h-4 rounded-full bg-[#25D366] flex items-center justify-center">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/></svg>
        </div>
        <span className="text-[10px] font-medium text-[#999]">Anteprima</span>
      </div>
      <div className="bg-[#ECE5DD] rounded-xl p-2.5" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'200\' height=\'200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cdefs%3E%3Cpattern id=\'a\' width=\'40\' height=\'40\' patternUnits=\'userSpaceOnUse\'%3E%3Ccircle cx=\'20\' cy=\'20\' r=\'1\' fill=\'%23d4cfc4\' /%3E%3C/pattern%3E%3C/defs%3E%3Crect width=\'200\' height=\'200\' fill=\'url(%23a)\' /%3E%3C/svg%3E")' }}>
        <div className="bg-[#DCF8C6] rounded-xl rounded-tr-sm p-3 max-w-[90%] ml-auto shadow-sm">
          <div className="text-[11px] text-[#303030] leading-relaxed whitespace-pre-wrap">
            {message.split('\n').map((line, i) => (
              <React.Fragment key={i}>{i > 0 && <br />}{line}</React.Fragment>
            ))}
          </div>
          <div className="flex items-center justify-end gap-1 mt-1.5">
            <span className="text-[9px] text-[#8a8a8a]">{new Date().toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}</span>
            <Check size={9} className="text-[#53BDEB]" />
          </div>
        </div>
      </div>
    </div>
  );
}
